import React, {useState, useEffect} from "react"
import './App.css';
import WeatherApp from "./Components/WeatherApp/WeatherApp.jsx"
import SplashScreen from "./SplashScreen";

function App() {
  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    // Simulate an app loading delay
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 2000); // Adjust the time as needed
  
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={`App ${showSplash ? 'hide-app' : ''}`}>
      {showSplash ? (
      <SplashScreen />
       ) : ( <div>
    <div className="App">
      <WeatherApp />
    </div>
    </div>
       )}
    </div>
  );
}

export default App;
